import find from 'lodash/find'
import get from 'lodash/get'
import map from 'lodash/map'
import moment from 'moment'

// Quotation second reading date locally => first reading date + 6 month
// The idea is to hide price after second reading date
const fetchSecondReadingDate = function (values) {
    const item = find(values, 'nextReading')
    return item ? moment({ year: item.year, month: item.month - 1 }).add(6, 'month') : moment.invalid()
}

const mapTimetableItemToGraphData = (secondReadingDate) => function (item) {
    const momentDate = moment({ year: item.year, month: item.month - 1 })
    return {
        date: momentDate.format('YYYY-MM-DD'),
        amount: Math.floor(item.total * 100) / 100,
        sleeked: Math.floor(item.sleeked * 100) / 100,
        nextReading: get(item, 'nextReading', false) || secondReadingDate.isSame(momentDate, 'month'),
    // Don't display price after second reading date
        amountDisplay: !secondReadingDate.isValid() || momentDate.isBefore(secondReadingDate, 'month'),
    }
}

function timelineToGraphData(values) {
    return map(values, mapTimetableItemToGraphData(fetchSecondReadingDate(values))).slice(0, 12)
}

export default timelineToGraphData



// WEBPACK FOOTER //
// ./src/services/timeline/timeline.js